module.exports = __webpack_public_path__ + "img/icon_home_supreme_top.736c4096.png";